document.addEventListener("DOMContentLoaded", () => {
    const video = document.querySelector("#homepage-video");

    if (video) {
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

        if (isSafari) {
            const source = document.querySelector("#homepage-video");
            source.setAttribute("src", "/global/images/homepage_video-hevc-safari.mp4");
            source.setAttribute("type", "video/mp4");
            source.setAttribute("codecs", "hevc");
        }

        video.addEventListener("ended", () => {
            video.currentTime = 4.000;
            video.play();
        });
    }
});
